import { handleActions } from "redux-actions";
import { Set } from "immutable";
import {
    ACTIVE_LIST_ADD,
    ACTIVE_LIST_CLEAR,
    ACTIVE_LIST_ENTRIES_FAILURE,
    ACTIVE_LIST_ENTRIES_REQUEST,
    ACTIVE_LIST_ENTRIES_SUCCESS,
    ACTIVE_LIST_REMOVE,
    ACTIVE_LIST_REMOVE_REQUEST,
    ACTIVE_LIST_SET,
} from "constants/action-types";

const initialState = {
    current: null,
    entries: new Set(),
};

const activeListReducer = handleActions(
    {
        [ACTIVE_LIST_SET]: (state, { payload }) => {
            return Object.assign({}, state, {
                current: payload,
                entries: new Set(),
            });
        },
        [ACTIVE_LIST_CLEAR]: (state) => {
            return Object.assign({}, state, {
                current: null,
                entries: new Set(),
            });
        },
        [ACTIVE_LIST_ENTRIES_SUCCESS]: (state, { data }) => {
            let entries = state.entries;
            data.forEach((entry) => (entries = entries.add(entry.item_id)));
            return Object.assign({}, state, { entries });
        },
        [ACTIVE_LIST_ENTRIES_REQUEST]: (state) => {
            return Object.assign({}, state, { entries: state.entries.clear() });
        },
        [ACTIVE_LIST_ENTRIES_FAILURE]: (state) => {
            return Object.assign({}, state, { entries: state.entries.clear() });
        },
        [ACTIVE_LIST_ADD]: (state, { payload }) => {
            let entries = state.entries;
            payload.forEach((entry) => {
                entries = entries.add(entry);
            });
            return Object.assign({}, state, { entries });
        },
        [ACTIVE_LIST_REMOVE]: (state, { payload }) => {
            let entries = state.entries;
            payload.forEach((entry) => {
                entries = entries.delete(entry);
            });
            return Object.assign({}, state, { entries });
        },
        [ACTIVE_LIST_REMOVE_REQUEST]: (state, { itemIds }) => {
            let entries = state.entries;
            itemIds.forEach((entry) => {
                entries = entries.delete(entry);
            });
            return Object.assign({}, state, { entries });
        },
    },
    initialState
);

export default activeListReducer;
